module.exports = __webpack_public_path__ + "media/landing_page/instagram-cashew-1ae44129.svg";